const fontFamily =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

export const blueTheme = {
  colors: {
    primary: '#2563eb',
    primaryHover: '#1d4ed8',
    primaryActive: '#1e40af',
    primaryLight: '#e7eefe',
    primaryLighter: '#f0f5ff',

    antdPrimary: '#1890FF',

    success: '#178a5a',
    warning: '#b06a16',
    error: '#c33a52',
    info: '#2956c9',

    // Blue accent scale (same family as primary/primaryHover/primaryActive above)
    purple: {
      50: '#eff6ff',
      100: '#dbeafe',
      200: '#bfdbfe',
      300: '#93c5fd',
      400: '#60a5fa',
      500: '#3b82f6',
      600: '#2563eb', // Main primary
      700: '#1d4ed8',
      800: '#1e40af',
      900: '#1e3a8a',
    },

    white: '#ffffff',
    black: '#000000',
    gray: {
      50: '#f8fafc',
      100: '#f1f5f9',
      200: '#e2e8f0',
      300: '#cbd5e1',
      400: '#94a3b8',
      500: '#64748b',
      600: '#475569',
      700: '#334155',
      800: '#1e293b',
      900: '#0f172a',
    },

    background: '#f4f5f8',
    surface: '#ffffff',
    sidebar: '#0e1a36',
    sidebarHover: 'rgba(255,255,255,0.05)',
    sidebarBorder: 'rgba(255,255,255,0.1)',

    textPrimary: '#0f1729',
    textSecondary: '#475067',
    textDisabled: '#9aa2b4',

    border: '#d7dbe3',
    borderLight: '#e6e8ee',

    cardBackground: '#ffffff',
    cardHover: '#f4f5f8',

    successLight: '#e3f6ec',
    warningLight: '#fff5e8',
    errorLight: '#fdeaec',
    infoLight: '#e7eefe',

    tagColors: {
      purple: '#4f46e5',
      magenta: '#eb2f96',
      geekblue: '#2f54eb',
      cyan: '#13c2c2',
      blue: '#2563eb',
      volcano: '#fa541c',
      orange: '#fa8c16',
      gold: '#faad14',
      green: '#52c41a',
    },
  },

  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
    standard: '16px',
    compact: '12px',
    relaxed: '24px',
  },

  borderRadius: {
    sm: '4px',
    md: '6px',
    lg: '10px',
    xl: '12px',
  },

  shadows: {
    sm: '0 1px 2px rgba(16,23,41,.04), 0 1px 3px rgba(16,23,41,.03)',
    md: '0 4px 6px -1px rgba(16,23,41,.08), 0 2px 4px -1px rgba(16,23,41,.05)',
    lg: '0 10px 30px rgba(16,23,41,.10), 0 4px 10px rgba(16,23,41,.06)',
  },

  typography: {
    fontFamily,
    mono: "'SF Mono', ui-monospace, Menlo, Consolas, monospace",
    fontSize: {
      xxs: '8px',
      xs: '12px',
      sm: '13.5px',
      md: '14px',
      lg: '16px',
      xl: '18px',
      xxl: '20px',
      xxxl: '24px',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
  },

  breakpoints: {
    xs: '480px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    xxl: '1600px',
  },
};

export type BlueTheme = typeof blueTheme;
